/*
 * User Tracking Support Scripts
 * =============================
 * Scripts that aid in tracking web statistics and other anonymous user data
 *
 */

//---------------------------------------------------------------------||
// FUNCTION:    InitOffsiteLinks                                       ||
// PARAMETERS:                                                         ||
// RETURNS:     Nothing                                                ||
// PURPOSE:     Adds onClick event to all href's that direct off site  ||
//---------------------------------------------------------------------||
var Track = (function() {

	var cookieConsentDomain = "century21.com";
	var functionalConsentQueue = [];
	var adConsentQueue = [];
	var functionalTagsApproved = false;
	var adTagsApproved = false;

	function getCookieConsent(type, cb) {
		//console.log('getCookieConsent', type);
		if (window.truste && window.truste.cma) {
			var response = truste.cma.callApi("getConsent", cookieConsentDomain, null, null, type);
			if(window.console) {
				console.info('Cookie consent updated for ' + type + " - " + response.consent);
			}
			if (response.consent == "approved") {
				cb(true);
			} else {
				cb(false);
			}
		} else {
			setTimeout(function () {
				getCookieConsent(type, cb);
			}, 100);
		}
	}

	var cookieConsentHandler = function(e) {
		//console.log('cookieConsentHandler called....', e);
		try {
			var responseJson = JSON.parse(e.data);
			if (responseJson.hasOwnProperty('PrivacyManagerAPI') ||
				responseJson.source === 'preference_manager'
			) {
				getCookieConsent("advertising", function (isApproved) {
					adTagsApproved = isApproved;
					if (adTagsApproved && adConsentQueue.length > 0) {
						for (var i = 0; i < adConsentQueue.length; i++) {
							adConsentQueue[i]();
						}
						adConsentQueue = [];
					}
					if(!adTagsApproved) {
						// Hide the share button.
						$('.action-primary-share').hide();
					}
				});

				getCookieConsent("functional", function (isApproved) {
					functionalTagsApproved = isApproved;
					if (functionalTagsApproved && functionalConsentQueue.length > 0) {
						for (i = 0; i < functionalConsentQueue.length; i++) {
							//console.log('processing functional queue');
							functionalConsentQueue[i]();
						}
						functionalConsentQueue = [];
					}
				});
			}
		} catch (error) {
			// Per TrustArc - this is their recommended way of handling,
			// sometimes data is JSON encoded in a string, sometimes it's
			// other stuff too so we just try to parse the JSON and swallow the errors. :(
			//console.log('Cookie consent error: ', error);
		}
	}

	this.initializeCookieConsent = function() {
		//console.log("Initalize cookie consent");
		var apiObject = {
			PrivacyManagerAPI: {
				action: "getConsent",
				timestamp: new Date().getTime(),
				self: cookieConsentDomain
			}
		};
		var apiResponseJson = JSON.stringify(apiObject);
		window.top.postMessage(apiResponseJson, "*");
		window.addEventListener("message", cookieConsentHandler, false);
	}

	this.includeFunctionalTag = function(callback, forceToTop) {
		if (functionalTagsApproved) {
			callback();
		} else {
			if (forceToTop) {
				functionalConsentQueue.unshift(callback);
			} else {
				functionalConsentQueue.push(callback);
			}
		}
	}

	this.includeAdTag = function(callback, forceToTop) {
		if (adTagsApproved) {
			callback();
		} else {
			if(forceToTop) {
				adConsentQueue.unshift(callback);
			} else {
				adConsentQueue.push(callback);
			}
		}
	}

	this.initOffsiteLinks = function() {
	   if (window.disableGATracking == true) {
	      return;
	   }
	   var strServerName;
	
	   if( document.getElementsByTagName ) {
	      var aTags = document.getElementsByTagName('a');
	      var iAnchorCount = aTags.length;
	      for (var i=0; i < iAnchorCount; i++) {
	         if (aTags[i].href) {
	            strServerName = getServerName(aTags[i].getAttribute('href'));
	            if (strServerName.length > 0) {
	               if (!isValidC21Server(strServerName)) {
	                  //Handle WTOD link tracking
	                  var strLinkType = aTags[i].getAttribute('linktype');
	                  var className = aTags[i].className;
	                  
	                  // Check if there is a css class to ignore offsite title 
	                  var bIgnoreOffsiteTitle = false;
	                  if(className != null && className.indexOf("ignoreOffsiteTitle") > -1) {
	                     bIgnoreOffsiteTitle = true;
	                  }
	                  
	                  //Handle offsite link legal disclaimer
	                  if(!bIgnoreOffsiteTitle) {
	                     var strOriginalLinkTitle = aTags[i].getAttribute('title');
						  var attrCheck = aTags[i].hasAttribute('data-title');
						  if(!attrCheck) {
							  var strNewTitle = g_internationalization.getString('You have selected a link to a website that is not owned or maintained by Century21.com. Different terms of use and privacy policies will apply.');
						  } else {
							  var strNewTitle = aTags[i].getAttribute('data-title');
						  }

						  if( strOriginalLinkTitle && strOriginalLinkTitle.indexOf(strNewTitle) < 0 ) {
	                        strNewTitle += ' ' + strOriginalLinkTitle;
	                     }
	                     aTags[i].setAttribute("title", strNewTitle);
	                  }
	                  
	                  aTags[i].setAttribute("target", "_BLANK");
	               }
	            }
	         }
	      }
	   }
	}

	function getServerName(strValue) {
	   var strServerName;
	   var iParmLocation;
	
	   strServerName = strValue.toLowerCase();
	
	   iParmLocation = strServerName.indexOf("?");
	   if (iParmLocation >= 0) {
	      strServerName = strServerName.substring(0,iParmLocation);
	   }
	   if (strServerName.indexOf("http") == 0) {
	      iParmLocation = strServerName.indexOf("https://");
	      if (iParmLocation >= 0) {
	         strServerName = strServerName.substring((iParmLocation+8),strServerName.length);
	      }
	      iParmLocation = strServerName.indexOf("http://");
	      if (iParmLocation >= 0) {
	         strServerName = strServerName.substring((iParmLocation+7),strServerName.length);
	      }
	      iParmLocation = strServerName.indexOf("/");
	      if (iParmLocation >= 0) {
	         strServerName = strServerName.substring(0,iParmLocation);
	      }
	   } else {
	      strServerName = "";
	   }
	
	   return strServerName;
	}

	function isValidC21Server(strServerName) {
	   var CurrentServer = document.location.host.toLowerCase();
	
	   if( strServerName.indexOf(".c21.com") >= 0 ){
	      return true;
	   }
	   if( strServerName == "c21.com" ){
	      return true;
	   }
	   if( strServerName.indexOf(".century21.com") >= 0 ){
	      return true;
	   }
	   if( strServerName == "century21.com" ){
	      return true;
	   }
	   if( strServerName.indexOf(".netmovein.com") >= 0 ){
	      return true;
	   }
	   if( strServerName.indexOf(".century21mortgage.com") >= 0 ){
	      return false; // in case they change their mind
	   }
	   if( strServerName == CurrentServer ){
	      return true;
	   }
	
	   return false;
	}

	this.c21Reporting = function(strWhat, strType, strKey ) {
	   if (window.disableGATracking == true) {
	      return;
	   }
	   if( strKey.charAt(0) >= 'A' && strKey.charAt(0) <= 'Z' ) return;
	   var pIframe = document.getElementById( 'messagequeueiframe' );
	   if( pIframe ) {
	      var strRndId = ""+(Math.random() * 10000000000000);
	      pIframe.src = '/reporting/'+strWhat+'?id='+strKey+'&type=' + strType + '&rnd=' + strRndId;
	   }
	   return true;
	}
	
   gaEventTrack = function(sCategory, sAction, sLabel, sValue) {
      if (window.disableGATracking == true) {
         return;
      }
      
      // Espanol Site Tracker: Prepend 'ESP' to action
      if(window.websiteCode == 'ESP') {
         sAction = 'ESP ' + sAction;
      }
      
      //console.log("Event Tracker: [" + aEvent + "]");

		 // Note: GA (UA) is deprecated. Migrated to GA4.

		 // if(window.ga) {
     //     //This 4th Parameter must be an Integer by GA Standards
     //     var hasValue = false;
     //     if ((sValue !== null && sValue !== "") || (sValue === 0)) {
     //        var intRegex = /^\d+$/;
     //        if (!isNaN(sValue) && intRegex.test(sValue)) {
     //           hasValue = true;
     //        }
     //     }
		 //
		 //  this.includeFunctionalTag(function() {
			//   if (hasValue) {
			// 	  window.ga('send', 'event', sCategory, sAction, sLabel, sValue);
			//   } else {
			// 	  window.ga('send', 'event', sCategory, sAction, sLabel);
			//   }
		 //  });
     //  }
   }
   
   gaPageTrack = function(tracker, title) {
      if (window.disableGATracking == true) {
         return;
      }
      
      //console.log("Page tracker: ["+tracker+"]");

		 // Note: GA (UA) is deprecated. Migrated to GA4.

		 // if(window.ga) {
		 //  this.includeFunctionalTag(function() {
			//   if (title) {
			// 	  window.ga('send', 'pageview', {
			// 		  page: tracker,
			// 		  title: title
			// 	  });
			//   } else {
			// 	  window.ga('send', 'pageview', tracker);
			//   }
		 //  });
     //  }
   }
	
	this.doEvent = function(sCategory, sAction, sLabel, sValue) {
	   if (window.disableGATracking == true) {
	      return;
	   }
	   	   
	   gaEventTrack(sCategory, sAction, sLabel, sValue);
	   c21Helpers.stopEvent();
	}

	this.doEventByPropTypeLabel = function(sCategory, sAction, brandCd) {
		var sLabel = "";
		if(brandCd != null && brandCd != "" && brandCd != "undefined") {
			if(brandCd == 'REN' || brandCd == 'C21') {
				sLabel = brandCd;
			} else {
				sLabel = 'sister';
			}
		}
		if(sLabel != "") {
			Track.doEvent(sCategory, sAction, sLabel);	
		} else {
			Track.doEvent(sCategory, sAction);
		}		
	}
	
	
	this.doTracking = function(tracker) {
	   if (window.disableGATracking == true) {
	      return;
	   }
	   switch (tracker) {
	      default:
            gaPageTrack('/conversions/' + tracker);
	         break;
	   }
	}
		    
	return this;
}());
$(document).ready(function() {
	Track.initOffsiteLinks();
});
Track.initializeCookieConsent();
